import { render } from "./MemoryGame.vue?vue&type=template&id=a82e1de6"
import script from "./MemoryGame.vue?vue&type=script&lang=js"
export * from "./MemoryGame.vue?vue&type=script&lang=js"

import "./MemoryGame.vue?vue&type=style&index=0&id=a82e1de6&lang=css"

import exportComponent from "D:\\eestec sajt trenutni\\eestec.etf.rs\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__